module.exports = __webpack_public_path__ + "img/mcgl_tyg_04.99339c40.png";